import { DetailManyToOneTable } from '@/@diffrag/form/DetailManyToOneTable'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { OffsetPagination } from '@/@diffrag/OffsetPagination'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { TableFormatter } from '@/@diffrag/table/TableFormatter'
import { api } from '@/api'
import { AdminFaqListData, IFaqRO } from 'api'
import { useNavigate } from 'react-router-dom'

export default function Faq() {
  const navigate = useNavigate()
  const { data, isFetching, refetch } = useApi({
    id: 'faqList',
    fn: api().adminFaq.adminFaqList,
  })

  const onSave = async (rows: AdminFaqListData) => {
    const deletedItems = data?.items.filter(
      (item) => !rows.items.some((rowItem) => rowItem.id === item.id),
    )

    if (deletedItems?.length) {
      await api().adminFaq.adminFaqDelete({
        ids: deletedItems.map((item) => item.id),
      })
    }

    for (const row of rows.items) {
      if (row.id) {
        await api().adminFaq.adminFaqUpdate(row.id, {
          question: row.question,
          answer: row.answer,
          order: row.order,
        })
      } else {
        await api().adminFaq.adminFaqCreate({
          question: row.question,
          answer: row.answer,
          order: row.order,
        })
      }
    }
  }

  const onDelete = async (rows: IFaqRO[]) => {
    Promise.all(
      rows.map((row) =>
        api().adminFaq.adminFaqDelete({
          ids: [row.id],
        }),
      ),
    )

    refetch()
  }

  return (
    <ContentView>
      <SimpleTable
        onDelete={onDelete}
        isLoading={isFetching}
        options={{
          disableNew: true,
          disableSort: true,
        }}
        createHref="/faq/detail"
        data={data?.items}
        onRowClick={(row) => {
          navigate(`/faq/detail?id=${row.id}`)
        }}
        columns={[
          {
            key: 'id',
            label: 'NO',
            isPrimary: true,
            width: 50,
          },
          {
            key: 'question',
            label: '질문',
            isPrimary: true,
          },
        ]}
      />
    </ContentView>
  )
}
